import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import FormCheckboxControlLabel from './FormCheckboxControlLabel';

const FormCheckboxStack = ({
  options,
  spacing,
  stackProps,
}) => (
  <Stack
    direction="column"
    spacing={spacing}
    {...stackProps}
  >
    {options.map((option) => (
      <FormCheckboxControlLabel
        key={option.id}
        checked={option.checked}
        onChange={option.onChange}
        label={option.label}
        checkboxProps={option.checkboxProps}
        typographyProps={option.typographyProps}
      />
    ))}
  </Stack>
);

FormCheckboxStack.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.node.isRequired,
    checkboxProps: PropTypes.shape({}),
    typographyProps: PropTypes.shape({}),
  })),
  spacing: PropTypes.number,
  stackProps: PropTypes.shape({}),
};

FormCheckboxStack.defaultProps = {
  options: [],
  spacing: 2,
  stackProps: {},
};

export default FormCheckboxStack;
